import { React } from "react";
import UserTableContainer from "./UserTableContainer";
import { createMedia } from "@artsy/fresnel";
import UserAppointmentsMobile from "./UserAppointmentsMobile";

const { MediaContextProvider, Media } = createMedia({
  breakpoints: {
    mobile: 0,
    tablet: 768,
    computer: 1024,
  },
});


export const UserScheduleAppointmentsPage = () => {
  return (
    <MediaContextProvider>
      <Media greaterThan="mobile">
        <UserTableContainer />
      </Media>
      <Media at="mobile">
        <UserAppointmentsMobile />
      </Media>
    </MediaContextProvider>
  );
};

export default UserScheduleAppointmentsPage;
